import { FormEvent, useRef, useState } from 'react'
import styled from 'styled-components'
import { NormalFormEmailField } from '../molecules'
import { Button, RowSpacer, WarnText } from '../atoms'
import { useUserLanguage } from '@/customHooks/useUserLanguage'
import textsData from '@/textData/ForgotPasswordTexts.json'
import { ForgotPasswordMutation, ResponseType, useForgotPasswordMutation } from '@/graphql/generated'
import { useNavigate } from 'react-router'
import { pathURL } from '@/components/constants/urls'
import { FetchResult } from '@apollo/client'
import { Col, Row } from 'react-grid-system'
import { useErrorHandlerContext } from '@/customHooks'

const FormContainer = styled.form`
  margin: 0 auto;
  padding: 20px;
  width: 80%;
`;

export const ForgotPasswordForm = () => {
  const userLanguage = useUserLanguage();
  const texts = userLanguage === 'es' ? textsData.es.forgotPassword : textsData.en.forgotPassword

  const emailDataRef = useRef<string | null>(null)
  const [isButtonDisabled, setIsButtonDisabled] = useState(true)
  const [isWarnTextHidden, setIsWarnTextHidden] = useState(true)

  const { open: errorHandle } = useErrorHandlerContext()

  const [forgotPasswordAction, { loading }] = useForgotPasswordMutation()

  const navigate = useNavigate()

  const onSuccessHandle = (response: FetchResult<ForgotPasswordMutation>) => {
    const forgotPasswordResponse = response.data?.forgotPassword
    if (!forgotPasswordResponse) return

    if (forgotPasswordResponse.responseType === ResponseType.Success) {
      navigate(`/${pathURL.LOGIN}/${pathURL.OTP_VALIDATION}`, { state: { email: emailDataRef.current } })
    } else {
      setIsWarnTextHidden(false)
      setIsButtonDisabled(true)
    }
  } 

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault(); // Evita el comportamiento predeterminado del formulario
    
    if (!emailDataRef.current) return

    forgotPasswordAction({ variables: { email: emailDataRef.current }})
      .then(onSuccessHandle)
      .catch(errorHandle)
  };

  const onChangeHandle = (value: string | null) => {
    if (!value) return

    const regexEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (regexEmail.test(value)) {
      setIsButtonDisabled(false)
      setIsWarnTextHidden(true)
      emailDataRef.current = value
    } else {
      setIsButtonDisabled(true)
      emailDataRef.current = null
    }
  }

  return (
    <FormContainer onSubmit={handleSubmit}>
      <Row>
        <Col>
          <NormalFormEmailField
            required
            label={texts.user}
            name="email"
            placeholder={texts.userPlaceholder}
            onChange={onChangeHandle}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <WarnText
            hidden={isWarnTextHidden}
            text={texts.warnText}
          />
        </Col>
      </Row>
      <RowSpacer height={3} />
      <Row>
        <Col>
          <Button
            submit
            upperCased
            isLoading={loading}
            disabled={isButtonDisabled}
          >
            {texts.button}
          </Button>
        </Col>
      </Row>
    </FormContainer>
  );
};
